import { render, staticRenderFns } from "./pinned-message.vue?vue&type=template&id=e4be947e&scoped=true&"
import script from "./pinned-message.vue?vue&type=script&lang=js&"
export * from "./pinned-message.vue?vue&type=script&lang=js&"
import style0 from "./pinned-message.vue?vue&type=style&index=0&id=e4be947e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4be947e",
  null
  
)

export default component.exports